/**
 * Google Analytics (balise gtag) : chargée une seule fois, après l'affichage de la page, et jamais par un navigateur
 * automatisé (le prérendu des pages ne doit ni compter comme une visite ni laisser le script dans le HTML généré).
 */
const MEASUREMENT_ID = 'G-852X59QW4R';

export class GoogleTagService {

    static start() {
        if (typeof window === 'undefined' || window.__googleTagLoaded) return;
        if (navigator.webdriver || /HeadlessChrome|Prerender|bot|crawl|spider/i.test(navigator.userAgent)) return;
        window.__googleTagLoaded = true;

        window.dataLayer = window.dataLayer || [];
        window.gtag = function () {
            window.dataLayer.push(arguments);
        };
        window.gtag('js', new Date());
        window.gtag('config', MEASUREMENT_ID);

        const script = document.createElement('script');
        script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
        script.async = true;
        document.body.appendChild(script);
    }

}
